import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';

const DeleteVolumeModal = ({ open, onClose, onDelete, volume, itemCount }) => {
  // Render footer for fixed footer
  const renderFooter = (
    <ModalFooter>
      <Button
        buttonStyle="danger"
        onClick={() => {
          onDelete();
          onClose();
        }}
        marginBottom0
      >
        <FormattedMessage
          id="ui-plugin-inventory-templates.volumeManagement.deleteVolumeModal.delete"
          defaultMessage="Delete Volume"
        />
      </Button>
      <Button onClick={onClose} marginBottom0>
        <FormattedMessage
          id="ui-plugin-inventory-templates.volumeManagement.deleteVolumeModal.cancel"
          defaultMessage="Cancel"
        />
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      open={open}
      footer={renderFooter}
      label={
        <FormattedMessage
          id="ui-plugin-inventory-templates.volumeManagement.deleteVolumeModal.label"
          defaultMessage="Delete Volume"
        />
      }
      onClose={onClose}
      size="small"
    >
      <div style={{ padding: '20px' }}>
        <p>
          <FormattedMessage
            id="ui-plugin-inventory-templates.volumeManagement.deleteVolumeModal.confirmation"
            values={{ volume, itemCount }}
            defaultMessage="Are you sure you want to delete volume {volume} and all its items ({itemCount} items)?"
          />
        </p>
        <p style={{ color: '#dc3545', fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.volumeManagement.deleteVolumeModal.warning"
            defaultMessage="This action cannot be undone."
          />
        </p>
      </div>
    </Modal>
  );
};

DeleteVolumeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  volume: PropTypes.string,
  itemCount: PropTypes.number,
};

export default DeleteVolumeModal;
